module.exports = __webpack_public_path__ + "static/img/anxun63.0f770a79.png";